module.exports = __webpack_public_path__ + "media/react/components/DailySequence/Slider/assets/foot_pedal-2f46fbc540d88b8d863526633d0268b8.svg";